/* Línea de pedido mínimo — Prix
   El mínimo de $25.000 vive en las condiciones de las tarifas de envío, así que bajo ese
   monto el checkout responde "no hay métodos de envío" sin explicar por qué. Esta línea lo
   dice antes. Va por JS y no editando plantillas porque el botón de pago aparece en dos
   lugares (página del carrito y cajón lateral) y el primero tiene código inyectado por
   Bsale que conviene no tocar. */
(function () {
  'use strict';

  var MINIMO = 25000;
  var TEXTO = 'Pedido mínimo: $25.000';

  var total = null;     // null = todavía no sabemos; no se pinta nada hasta saberlo
  var pidiendo = false;
  var encolado = false;

  function pintar() {
    var bajo = total !== null && total < MINIMO;

    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      var padre = ctas.parentNode;
      /* Se busca en TODO el contenedor, no solo en el elemento siguiente: el selector de
         entrega mete su propio aviso justo debajo del botón y desplaza al nuestro, que era
         lo que hacía que se duplicara. */
      var previas = padre.querySelectorAll(':scope > .prix-minimo');

      if (!bajo) {
        previas.forEach(function (n) { n.remove(); });
        return;
      }
      for (var i = 1; i < previas.length; i++) previas[i].remove();
      if (previas.length === 0) {
        var p = document.createElement('p');
        p.className = 'prix-minimo';
        p.textContent = TEXTO;
        padre.insertBefore(p, ctas.nextSibling);
      }
    });
  }

  function revisar() {
    if (pidiendo) return;
    pidiendo = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { total = c.total_price / 100; })
      .catch(function () {})
      .then(function () { pidiendo = false; pintar(); });
  }

  /* El tema no emite ningún evento de DOM al cambiar el carro (usa su propio pub/sub
     interno), así que la señal confiable es la petición misma. */
  var fetchOriginal = window.fetch;
  window.fetch = function () {
    var u = arguments[0];
    u = (typeof u === 'string' ? u : (u && u.url) || '');
    var esCarro = u.indexOf('/cart') !== -1 && u.indexOf('/cart.js') === -1;
    var p = fetchOriginal.apply(this, arguments);
    if (esCarro) p.then(function () { setTimeout(revisar, 150); }, function () {});
    return p;
  };

  /* El cajón lateral se vuelve a dibujar al abrirse: hay que repintar con lo ya sabido,
     sin volver a pedir el carro. */
  function repintarPronto() {
    if (encolado) return;
    encolado = true;
    requestAnimationFrame(function () { encolado = false; pintar(); });
  }

  function iniciar() {
    revisar();
    new MutationObserver(repintarPronto).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
